import {closeCookieMessage} from '../models/Util';

const closeAction = (caller) => {
    return {
        type: "CLOSE_COOKIE_DISCLAIMER",
        payload: closeCookieMessage(caller)
    }
};

export {closeAction};


// WEBPACK FOOTER //
// ./src/actions/Cookie.js